export function formatLocalDatetimeToIso(datetime: string) {
  return new Date(datetime).toISOString();
}
